export const faqData = [
  {
    id: "01",
    question:
      "What is a web app and how does it differ from a basic website? ",
    answer:
      "Unlike static websites, web applications deliver dynamic and data-powered experiences. Key features include personalized user dashboards, real-time database interactions, and automated workflows tailored to your specific business needs. ",
  },
  {
    id: "02",
    question:
      "Do web apps offer convenient content management? ",
    answer:
      "Yes. With headless CMS integration, we empower non-technical teams to manage content effortlessly and publish across multiple channels simultaneously from a single dashboard.",
  },
  {
    id: "03",
    question:
      "How do web apps provide better API control?",
    answer:
      "Web apps allow for granular API management by processing legacy outputs to modern standards, implementing rate limiting, and enabling centralized monitoring through one unified interface.",
  },
  {
    id: "04",
    question:
      "How do we choose the right cloud platform to host a web app?",
    answer:
      "We select from industry-proven platforms like AWS, Azure, Firebase, and Google Cloud. The choice is always based on the most efficient deployment of your architecture and cost-effectiveness. ",
  },
  {
    id: "05",
    question:
      "Can I upgrade my existing website to a full web app?",
    answer:
      "We have the technical prowess to transform sites built on legacy monolithic architecture into modern SaaS platforms. We use a modular approach to ensure a seamless transition during the upgrade. ",
  },
  {
    id: "06",
    question:
      " How do you ensure my web application remains fast as it grows?",
    answer:
      "We implement advanced performance strategies such as server-side caching, load balancing, and auto-scaling cloud functions. By using WebSockets for real-time data and optimizing your database queries, we ensure the user experience remains lightning-fast regardless of your total user count.",
  },
 
];